import { render } from "./DataTable.vue?vue&type=template&id=7e73e3aa&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=7e73e3aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e73e3aa"],['__file',"src/views/ServiceCenter/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e73e3aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e73e3aa', __exports__)) {
    api.reload('7e73e3aa', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=7e73e3aa&scoped=true", () => {
    api.rerender('7e73e3aa', render)
  })

}


export default __exports__